import Loading from '@/views/Loading.vue'

function LazyLoadView(AsyncView) {
  return {
    component: AsyncView,
    loading: Loading,
    delay: 150,
  }
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: Loading,
    delay: 150,
    // error: require('@views/_timeout.vue').default,
    // timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}

export { LazyLoadView }
